import {
  initializeAddressApiClient,
  initializeApiClient,
  initializeSharedI18N,
  reportErrorToConsole,
} from '@applyonline/shared'
import '@applyonline/shared/styles/base.css'
import '@applyonline/shared/styles/themes/default.css'
import '@applyonline/shared/styles/themes/iceberg.css'
import { DateFnsLocaleProvider } from '@if/core/date'
import i18n from '@if/core/i18n'
import { initializeTelemetry } from '@if/core/telemetry'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { I18nextProvider } from 'react-i18next'
import initializeGTM from './GTagManager'
import App from './containers/App/App'

initializeTelemetry({
  instrumentationKey: import.meta.env.VITE_APP_INSIGHT_INSTRUMENTAL_KEY,
  appName: 'applymechwarranty',
  appVersion: import.meta.env.VITE_VERSION,
})
initializeApiClient(import.meta.env.PROD, import.meta.env.VITE_BACKEND_API_URL)
initializeAddressApiClient(import.meta.env.PROD, import.meta.env.VITE_BACKEND_ADDRESSAPI_URL)
initializeGTM()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})
const container = document.getElementById('root')
const root = createRoot(container!)

const AppWrapper = () => {
  const recaptchaKey = import.meta.env.VITE_CAPTCHA_SITE_KEY || ''

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey} useEnterprise>
      <I18nextProvider i18n={i18n}>
        <DateFnsLocaleProvider>
          <App />
          <div
            style={{
              fontSize: '16px',
            }}
          >
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />
          </div>
        </DateFnsLocaleProvider>
      </I18nextProvider>
    </GoogleReCaptchaProvider>
  )
}

initializeSharedI18N()
  .then(() => {
    root.render(
      <QueryClientProvider client={queryClient}>
        <AppWrapper />
      </QueryClientProvider>,
    )
  })
  .catch(reportErrorToConsole)
